import { render } from "./pos-units.vue?vue&type=template&id=5f73163b"
import script from "./pos-units.vue?vue&type=script&lang=js"
export * from "./pos-units.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__